import { Stack, Typography } from '@mui/material';
import { m } from 'framer-motion';
import { MotionViewport, varFade, varSlide } from 'src/components/animate';
import Iconify from 'src/components/iconify';
import { Props } from 'src/features/@types/whyPafesan';
import { CustomContent, CustomRoot, StyledText } from './styles';

// ----------------------------------------------------------------------

export default function Differences({ data }: Props) {
  return (
    <Stack component={MotionViewport}>
      <m.div variants={varSlide().inUp}>
        <Typography variant="h4" align="center" mt={6} mb={3}>
          Por que a PAFESAN?
        </Typography>
      </m.div>
      <m.div variants={varSlide().inUp}>
        <StyledText variant="body1">
          A Pafesan é a melhor escolha para soluções em toldos em cobertura!
          <br />
          <br />
          Há mais de 10 anos atuando no mercado, proporcionamos aos nossos clientes garantia de
          qualidade de nossos produtos, com fabricação própria e o cuidado jamais visto em Vilhena e
          região.
        </StyledText>
      </m.div>

      <CustomRoot>
        <CustomContent>
          {data.map((content: any, index: number) => (
            <Stack key={index} style={{ alignItems: 'center' }}>
              <m.div variants={varSlide().inRight}>
                <Iconify icon={content.icon} color="common.white" width={100} />
              </m.div>

              <m.div variants={varFade().inUp}>
                <Typography variant="h5" color="common.white">
                  {content.label}
                </Typography>
              </m.div>
            </Stack>
          ))}
        </CustomContent>
      </CustomRoot>
    </Stack>
  );
}
